import { render, staticRenderFns } from "./RoomCall.vue?vue&type=template&id=7537b474&scoped=true&"
import script from "./RoomCall.vue?vue&type=script&lang=js&"
export * from "./RoomCall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7537b474",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7537b474')) {
      api.createRecord('7537b474', component.options)
    } else {
      api.reload('7537b474', component.options)
    }
    module.hot.accept("./RoomCall.vue?vue&type=template&id=7537b474&scoped=true&", function () {
      api.rerender('7537b474', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Sysadmin/RoomCall.vue"
export default component.exports